
import BaseView from "@core/View.js";
import {$util} from "@util/util.js";
import Alert from "@util/alert.js";
export default class GiftListWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        // console.log('初始数据',this._model);

        this._parentEl = this._model._parent._view._giftBoxEl;
        this._el = null;
    }
    itemsdfsd(item){
      if (item.invalid) {
        return `<div class="price_Red">已赠完</div>`;
      }else  if(item.stock <= 0) {
        return `<div class="price_Red">已赠完</div>`;
      } else if(item.stock >= 1 && item.stock < this._model._parent._count) {
        return `<div class="price_Red">还有${item.stock}件</div>`;
      }else {
        return `<div class="price_able"><span>x</span>${item.num}</div>`
      }
    }
    getDefault(){
        let html = '';
        this._model._parent._gift._data.map((item,index)=>{
          // 是否展示重选按钮
          if(!item.optionGiftFlag) {
            html += `<div class="item ${(item.stock <= 0 || item.invalid) ? 'disable' : ''}">
                <div class="i_checkbox default">
                默认
                <!-- <input type="checkbox" class="item_checkbox disabled"> -->
                </div>
                <div class="i_img">
                <img src="${item.imgUrl}" alt="">
                <div class="already_sold_box"></div>
                </div>
                <div class="item_right">
                <h3 class="good_name">${item.name}</h3>
                <div class="i_price">
                 ${this.itemsdfsd(item)}
                </div>
                </div>
            </div>`
          }
            
        })
      return html
    }
    initData() {
      // 一进页面把数据初始化checkstatus
      this._model._giftList.map((item2,index2)=> {
        item2.checkstatus = 0;
      })
      // 在这里处理已经选择的赠品的一进页面就自动选中
      this._model._parent._gift._data.map((item,index)=> {
        this._model._giftList.map((item2,index2)=> {
          if(item.id == item2.code && item.optionGiftFlag) {
            item2.checkstatus = 1;
            item2.num = item.num;
          }
        })
      })
    }
    getItems() {
        let html = '';
        html += `<h4>可选择的赠品：</h4>`;
        this._model._giftList.map((item,index)=>{
            html += `<div class="item ${item.status ? '' : 'disable'} jumpDetail">
              <div class="i_checkbox">
                <i class="iconfont ${item.status==0 ? item.checkstatus ?'icon-checked':'icon-disabled' : item.checkstatus ? 'icon-checked' : 'icon-uncheck'} item_checkbox" data-status="${item.status}" data-code="${item.code}"></i> <!--disabled-->
              </div>
              <a href="${item.goodsDetailUrl}">
              <div class="i_img">
                <img src="${item.path}" alt="">
                <div class="already_sold_box"></div>
              </div>
              </a>
              
              <div class="item_right">
              <a href="${item.goodsDetailUrl}">
                <h3 class="good_name">${item.goodsName}</h3>
                <div class="i_price">
                  `;
                  // 失效状态一般包括下架和没库存, 所以这里只判断status为0的时候就好
                  if(!item.status && item.stockNum == 0) {
                    html+=`<div class="price_disable">已赠完</div>`;
                  } else if (!item.status && item.stockNum > 0) {
                    html+=`<div class="price_disable">已赠完</div>`;
                  } else if(item.stockNum >= 1 && item.stockNum < this._model._parent._count) {
                    html+=`<div class="price_Red">还有${item.stockNum}件</div>`;
                  } else  {
                    html+=`<div class="price_able" style="display:${item.status ? 'block;' : 'none;'}"><span>x</span>${ this._model._parent._count}</div>`;
                  }
                  html+=`
                </div>
                </a>
              </div>
              
            </div>`
        })
        return html;
    }

    render(){
      // 初始化数据
      this.initData();
        let html = "";
        html += `${this.getDefault()}${this.getItems()}`;
        $(this._parentEl.find("div.option_common_content")).html($(html));
        this._el = $(".receive_wrapper");
        // 每次render都清空选择了几件服务
        $('.receive_wrapper .option_common_bottom p span').html('0')
        this.regEvent();
    }
    regEvent() {
        let that = this;
        // 点击选择服务叉号, 隐藏弹窗icon-close
        this._el.off("click", ".icon-close").on("click", ".icon-close", function () {
            $(".receive_wrapper").hide();
            $util.toggleBodyScroller(false);
        })
        
        // 点击checkbox
        this._el.off("click", "div.i_checkbox i").on("click", "div.i_checkbox i", function () {
            let status = $(this).attr('data-status');
            // console.log('当前选中的状态',status);
            // 因为赠品是单选的 , 每次选中前就要清空上次选择的内容
            if(!$(this).hasClass('icon-checked')) {
                // 未选中状态 ,判断其余的是否失效 , 如果有失效就添加class
                $('.receive_wrapper .option_common_content .item div.i_checkbox i').each((index,item)=> {
                  if($(item).attr('data-status') == 0) {
                      $(item).removeClass('icon-checked').addClass('icon-disabled')
                  } else {
                    $('.receive_wrapper .option_common_content .item div.i_checkbox i').addClass('icon-uncheck').removeClass('icon-checked');
                    $(this).addClass('icon-checked');
                  }
              })
                
            } else if($(this).hasClass('icon-checked')) {
              // 在判断是不是失效 ,如果失效直接到失效样式
              if(status == 0) {
                $('.receive_wrapper .option_common_content .item div.i_checkbox i').addClass('icon-uncheck').removeClass('icon-checked');
                $(this).addClass('icon-disabled').css('pointer-events','none');
              } else {
              $('.receive_wrapper .option_common_content .item div.i_checkbox i').removeClass('icon-checked');
              $(this).addClass('icon-uncheck');
            }

            }
        })
        // 点击确定按钮发送请求
        // 点击checkbox
        this._el.off("click", "div.option_common_bottom button").on("click", "div.option_common_bottom button", function () {
            var gcodes = [];
            $('.receive_wrapper .option_common_content .i_checkbox i.icon-checked').each((index,item)=> {
                gcodes.push($(item).attr('data-code'));
            })
            that._model._parent.modifyItemFromCart({opsType:2,content:gcodes.join('@')}).then( () =>{
              $(".receive_wrapper").hide();  
              $util.toggleBodyScroller(false); 
            }).catch(err =>{
              Alert.showTip(err);
            });
             
            
        })
    }
}

